import { render, staticRenderFns } from "./CadastrarNovoUsuario.vue?vue&type=template&id=353b3026&"
import script from "./CadastrarNovoUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastrarNovoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports